import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CInputtextComponent } from './c-inputtext.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AsPipesModule } from '../../../pipes/as-pipes/as-pipes.module';
@NgModule({
  declarations: [CInputtextComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    IonicModule,
    AsPipesModule,
  ],
  exports: [CInputtextComponent]
})
export class CInputtextModule { }
